module.exports = __webpack_public_path__ + "static/media/bce.c5b2a276.png";